import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { FormWizardModule } from 'angular2-wizard';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrderModule, OrderPipe } from 'ngx-order-pipe';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
// import { AmChartsModule, AmChartsService } from '@amcharts/amcharts3-angular';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CookieService } from 'ngx-cookie-service';
import { RouterModule } from '@angular/router';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ModalModule, BsModalService  } from 'ngx-bootstrap/modal';
import { SortablejsModule } from 'ngx-sortablejs'
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatDrpModule } from 'ngx-mat-daterange-picker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import { NgIdleModule } from '@ng-idle/core';
import { DatepickerModule, BsDatepickerModule  } from 'ngx-bootstrap/datepicker';

import { appRoutes } from './routes';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TopnavbarComponent } from './_layout/topnavbar/topnavbar.component';
import { SidebarComponent } from './_layout/sidebar/sidebar.component';
import { FooterComponent } from './_layout/footer/footer.component';
import { LayoutComponent } from './_layout/layout/layout.component';
import { LoginComponent } from './login/login.component';
import { AccountsComponent } from './accounts/accounts.component';
import { HttpinterceptorService } from './services/interceptor/httpinterceptor.service';
import { AmchartsComponent } from './amcharts/amcharts.component';
import { PwdResetComponent } from './pwd-reset/pwd-reset.component';
import { ProfileComponent } from './profile/profile.component';
import { RecoverpwdComponent } from './recoverpwd/recoverpwd.component';
import { ServiceProviderComponent } from './service-provider/service-provider.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { WorkflowCustomizationComponent } from './workflow-customization/workflow-customization.component';
import { DeviceComponent } from './device/device.component';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { FieldCustomizationComponent } from './field-customization/field-customization.component';
// import { CustomPipes } from './app.customPipes';
import { SafePipe } from './app.customPipes';
import { PaymentDashboardComponent } from './payment-dashboard/payment-dashboard.component';
import { ConfigurationsComponent } from './configurations/configurations.component';
import { PaymentSubscriptionComponent } from './payment-subscription/payment-subscription.component';
import { PackagesComponent } from './packages/packages.component';
import { SearchPackagePipe } from './packages/searchPackagePipe.pipe';
import { PaymentStatisticsComponent } from './payment-statistics/payment-statistics.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { PackageValidityExtensionComponent } from './package-validity-extension/package-validity-extension.component';
import { OfflinePaymentComponent } from './offline-payment/offline-payment.component';
import { CountUpModule } from 'countup.js-angular2';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { ProviderConfigurationComponent } from './provider-configuration/provider-configuration.component';
import { TelecareDashboardComponent } from './telecare-dashboard/telecare-dashboard.component';
import { ArchwizardModule } from 'angular-archwizard';
import { TooltipModule, TooltipOptions } from 'ng2-tooltip-directive';
import { IncentiveConfigComponent } from './incentive-config/incentive-config.component';
import { LabelConfigComponent } from './label-config/label-config.component';
import { OperatorIncentiveReportComponent } from './operator-incentive-report/operator-incentive-report.component';
import { VisitConfigComponent } from './visit-config/visit-config.component';
import { FrameworkSettingsComponent } from './framework-settings/framework-settings.component';
import { FrameworkSettingsTeleeyeComponent } from './framework-settings-teleeye/framework-settings-teleeye.component';
import { SpectacleHomeComponent } from './spectacle-home/spectacle-home.component';
import { SpectacleVendorsComponent } from './spectacle-vendors/spectacle-vendors.component';
import { SpectacleVendorInfoComponent } from './spectacle-vendor-info/spectacle-vendor-info.component';
import { PackagesValidityComponent } from './packages-validity/packages-validity.component';
import { ScreeningsComponent } from './screenings/screenings.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { RescheduleComponent } from './appointments/reschedule/reschedule.component';
import { CustomNotificationsComponent } from './appointments/custom-notifications/custom-notifications.component';
import { ApiKeysComponent } from './api-keys/api-keys.component';
import { ExportExcelComponent } from './export-excel/export-excel.component';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    TopnavbarComponent,
    SidebarComponent,
    FooterComponent,
    LayoutComponent,
    LoginComponent,
    AccountsComponent,
    AmchartsComponent,
    PwdResetComponent,
    ProfileComponent,
    RecoverpwdComponent,
    ServiceProviderComponent,
    AdminUsersComponent,
    WorkflowCustomizationComponent,
    DeviceComponent,
    FieldCustomizationComponent,
    // CustomPipes,
    SafePipe,
    PaymentSubscriptionComponent,
    PaymentDashboardComponent,
    ConfigurationsComponent,
    PackagesComponent,
    SearchPackagePipe,
    PaymentStatisticsComponent,
    TransactionHistoryComponent,
    PackagesValidityComponent,
    PackageValidityExtensionComponent,
    ProviderConfigurationComponent,
    ScreeningsComponent,
    TelecareDashboardComponent, //custom filter pipe to search
    OfflinePaymentComponent, IncentiveConfigComponent, LabelConfigComponent, OperatorIncentiveReportComponent, VisitConfigComponent, FrameworkSettingsComponent, FrameworkSettingsTeleeyeComponent, SpectacleHomeComponent, SpectacleVendorsComponent, SpectacleVendorInfoComponent, ScreeningsComponent, AppointmentsComponent, RescheduleComponent, CustomNotificationsComponent, ApiKeysComponent, ExportExcelComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    // FormWizardModule,
    PerfectScrollbarModule,
    NgxMatDrpModule,
    BrowserAnimationsModule,
    CountUpModule,
    AngularMultiSelectModule,
    HttpClientModule,
    FormsModule,
    ArchwizardModule,
    NgxPaginationModule,
    // AmChartsModule,
    NgSelectModule,
    NgxUiLoaderModule,
    OrderModule,
    ModalModule.forRoot(),
    TableModule,
    InputSwitchModule,
    DropdownModule,
    SortablejsModule.forRoot({ animation: 150 }),
    RouterModule.forRoot(appRoutes),
    DialogModule,
    ReactiveFormsModule,
    ContentLoaderModule,
    NgMultiSelectDropDownModule.forRoot(),
    TooltipModule.forRoot({ 'placement': 'bottom', 'show-delay': 4000 } as TooltipOptions),
    NgIdleModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot()
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpinterceptorService,
    multi: true
  }, CookieService, DatePipe, Title, BsModalService],
  bootstrap: [AppComponent]
})
export class AppModule { }
